wbApp.controller('StudentsAttendanceDetailCtrl', ['$scope', 'attendanceSvc',
function ($scope, attendanceSvc) {

    var selectedStudent = null;
    var isActive = false;
    var loaded = false;
    $scope.attendanceDetail = [];

    $scope.$on('studentSelectionChanged', function (e, data) {
        if (data.student) {
            if (isActive) {
                if (selectedStudent !== data.student || data.refresh) {
                    $scope.attendanceDetail = attendanceSvc.groupAttendanceDetail(
                        attendanceSvc.getStudentAttendanceDetail(data.student.id));
                }
                loaded = true;
            } else {
                loaded = false;
            }
        } else {
            $scope.attendanceDetail.length = 0;
        }
        selectedStudent = data.student;
    });

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 4) {
            if (!isActive) {
                isActive = true;
                if (!loaded && selectedStudent) {
                    $scope.attendanceDetail = attendanceSvc.groupAttendanceDetail(
                        attendanceSvc.getStudentAttendanceDetail(selectedStudent.id));
                    loaded = true;
                }
            }
        } else {
            isActive = false;
        }
    });

    $scope.attendanceDetailFilterOptions = {
        filterText: ""
    };

    $scope.gridOptions = {
        columnDefs: [
            { field: 'course', displayName: "TXT_LBL_COURSE", sort: 'locale' },
            { field: 'attendanceCount', displayName: "TXT_LBL_COUNT", width: '55px' },
            { field: 'startDate', displayName: "TXT_LBL_START_DATE", cellFilter: 'date:dd.MM.yy - EEE HH:mm', width: '140px' },
            { field: 'endDate', displayName: "TXT_LBL_END_DATE", cellFilter: 'date:HH:mm', width: '55px' },
            { field: 'courseAttendanceStatus', displayName: "TXT_COL_ATTENDANCE_STATUS", cellFilter: 'attendanceStatus', width: '100px' },
            { field: 'courseAttendanceType', displayName: "TXT_COL_ATTENDANCE_TYPE", cellFilter: 'attendanceType', width: '100px' },
            { field: 'courseAttendanceFeeType', displayName: "TXT_LBL_COURSE_FEE", cellFilter: 'attendanceFeeType', width: '70px' },
            { field: 'teacherFullName', displayName: "TXT_LBL_EMPLOYEE", width: '140px', sort: 'locale' },
            { field: 'studentAttendanceNote', displayName: "TXT_LBL_NOTES",width: '180px', sort: 'locale' },
        ],
        noCommandColumn: true,
        pageSize: 20,
        disableRowSelection: true,
        grouping: {
            enabled: true,
            isGroupRowPropertyName: 'isGroupRow',
            subItemsPropertyName: 'items'
        }
    };

}]);


